import pd from './paletteHexDark';

var muiColorsDark = {
  primary1Color: pd.primary,
  primary2Color: pd.primaryH,
  primary3Color: pd.primaryLight,
  accent1Color: pd.grey400,
  accent2Color: pd.secondaryH,
  accent3Color: pd.secondaryH,
  textColor: pd.defaultText,
  secondaryTextColor: pd.secondaryText,
  alternateTextColor: pd.bgSurface,
  canvasColor: pd.bgSurface,
  borderColor: pd.border,
  disabledColor: pd.border,
  shadowColor: pd.black,
};

export default muiColorsDark;
